
import { BaseModel } from '../abstracts/base.model'

export class TrainingModel extends BaseModel {
    TrainingID: string
    CompanyID: string
    TrainingTypeID: string
    InstructorID: string
    TrainingName: string
    TrainingStartDate: Date
    TrainingEndDate: Date
    Description: string
    CompanyName: string
    ProviderID: number;
    VirtualClassProviderUrl: string;

    StatusID:number
    FullName:string
    ClassName:string
    StartDate:Date
    EndDate:Date

    MailTitle:string
    MailDescription:string
    ClassID:string
}